import React from "react";

import Wrapper from "../components/Wrapper";
import Sidebar from "../components/Sidebar";
import Main from "../components/Main";
import Content from "../components/Content";
import NavBar from "../components/Navbar";
import { LMThemeProvider, ToastContainer } from "@launchmetrics/lm-ui";

const Dashboard = ({ children }) => (
  <React.Fragment>
    <Wrapper>
      <LMThemeProvider>
        <ToastContainer />
        <Sidebar />
        <Main>
          <NavBar />
          <Content>{children}</Content>
        </Main>
      </LMThemeProvider>
    </Wrapper>
  </React.Fragment>
);

export default Dashboard;
